module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/8mill-active-0f4246f17287bbf6e82564b320fd8921.png";